import React from 'react';
import { Sidebar } from '@fingo/lib/components/layout';
import PurchasesSidePayable from '../views/App/purchases/PurchasesSidePayable';
import PurchasesSideProviders from '../views/App/purchases/PurchasesSideProviders';
import Home from '../views/App/purchases/Home';
import Funding from '../views/App/purchases/Funding';
import Summary from '../views/App/purchases/Summary';
import PurchasesConfirming from '../views/App/purchases/PurchasesConfirming';
import ConfirmingDashboard from '../views/App/purchases/home/ConfirmingDashboard';
import ConfirmingUpload from '../views/App/purchases/funding/ConfirmingUpload';
import PendingConfirming from '../views/App/purchases/summary/PendingConfirming';
import CurrentConfirming from '../views/App/purchases/summary/CurrentConfirming';
import HistoricalConfirming from '../views/App/purchases/summary/HistoricalConfirming';
import MyPurchases from '../views/App/purchases/payable/MyPurchases';
import MyProviders from '../views/App/purchases/providers/MyProviders';
import AppPayrollProfile from '../views/App/purchases/PayrollProfile';

const purchasesSubRoutes = () => [
  {
    id: 'purchases/confirming',
    label: 'Confirming',
    path: 'purchases/confirming',
    component: <PurchasesConfirming />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'confirming',
    label: 'confirming',
    path: 'confirming',
    component: [
      {
        id: 'home',
        label: 'Home',
        path: 'home',
        component: <Home />,
        disabled: false,
        show: false,
        showInSidebar: false,
      },
      {
        id: 'funding',
        label: 'Financiar nóminas',
        path: 'funding',
        component: <Funding />,
        disabled: false,
        show: false,
        showInSidebar: false,
      },
      {
        id: 'summary',
        label: 'Nóminas enviadas',
        path: 'summary',
        component: <Summary />,
        disabled: false,
        show: false,
        showInSidebar: false,
      },
    ],
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'purchases-side-payable',
    label: 'Cuentas por pagar',
    path: 'payable',
    component: <PurchasesSidePayable />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'purchases-side-providers',
    label: 'Proveedores',
    path: 'providers',
    component: <PurchasesSideProviders />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const homeTabs = () => [
  {
    id: 'home',
    label: 'Home',
    path: 'home',
    component: <ConfirmingDashboard />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const uploadConfirmingTabs = () => [
  {
    id: 'confirming-portfolio',
    label: 'Cartera de confirming',
    path: 'confirming-portfolio',
    component: <ConfirmingUpload />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const payrollTabs = () => [
  {
    id: 'pending',
    label: 'En curso',
    path: 'pending',
    component: <PendingConfirming />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'current',
    label: 'Vigentes',
    path: 'current',
    component: <CurrentConfirming />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
  {
    id: 'historical',
    label: 'Históricas',
    path: 'historical',
    component: <HistoricalConfirming />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const purchaseTabs = () => [
  {
    id: 'my-purchases',
    label: 'Cuentas por pagar',
    path: 'my-purchases',
    component: <MyPurchases />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

export const providersTabs = () => [
  {
    id: 'my-providers',
    label: 'Proveedores',
    path: 'contacts',
    component: <MyProviders />,
    disabled: false,
    show: false,
    showInSidebar: false,
  },
];

const purchasesRoutes = () => [
  {
    id: 'purchases',
    label: 'Mis compras',
    path: '/app/purchases',
    component: <Sidebar options={purchasesSubRoutes()} />,
    disabled: false,
    show: false,
    showInNavbar: false,
    subRoutes: purchasesSubRoutes(),
  },
  {
    id: 'payroll-profile',
    label: 'Operación de Confirming',
    path: '/app/payroll-profile',
    component: <AppPayrollProfile />,
    disabled: false,
    show: false,
    showInNavbar: false,
    subRoutes: [],
  },
];

export default purchasesRoutes;
